var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vs-number-input-container relative"},[_c('vx-input',_vm._g(_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.appliedMask),expression:"appliedMask"}],ref:"inputRef",staticClass:"vx-number-input",attrs:{"value":_vm.localValue,"inputmode":"tel"}},'vx-input',_vm.cmpAttrs,false),_vm.listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }